<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">{{ this.testInfo.examName }}</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <router-link to="/profile" class="face_header_rg">
          <span class="headsp"><img src="../assets/images/icon-user.png"/></span
          >{{ this.userInfo.userName }}
        </router-link>
      </div>
    </div>
    <!-- <div class="query_tit">
      <ul>
        <a href="javascript:void(0);" @click="readNotice()">1、阅读考试须知</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0);" @click="confirmInfo()">2、确认个人信息</a>
      </ul>
    </div> -->
    <div class="query_con">
      <h2 class="exam_con_t xz_t">重要提示</h2>
      <p class="ksxz_ft">
        <span class="ksxz_con"
          >重要提示，点击“开始考试”后开始正式考试，进入考试倒计<br />时，如未准备好考试，请点击“取消”。</span
        >
      </p>
      <div class="exam_stru_con">
        <div class="dt_btn">
          <a href="javascript:void(0)" @click="exit">取消</a>
          <a href="javascript:void(0)" @click="nextStep">开始考试</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getExamById, logout, myInfo } from "@/api/login";
export default {
  name: "FrontCameraPush",
  data() {
    return {
      examBean: {
        token: ""
      },
      tokenBean: {
        token: "",
        examUserId: ""
      },
      testInfo: {},
      userInfo: {},
      examUserId: "",
      allowResume: ""
    };
  },
  created() {
    this.examBean.token = this.getToken();
    this.examUserId = this.$route.query.examUserId;
    this.tokenBean.token = this.getToken();
    this.tokenBean.examUserId = this.examUserId;
    this.initData();
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      console.log(this.tokenBean);
      getExamById(this.tokenBean).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.testInfo = res.data;
          console.log(this.testInfo);
          this.allowResume = this.testInfo.allowResume;
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        }
      });
      myInfo(this.tokenBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.userInfo = res.data.user;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    nextStep() {
      this.$router.push({
        path: "/examCatalog",
        query: { examUserId: this.examUserId }
      });
    },
    readNotice() {
      this.$router.push({
        path: "/examNeedToKnow",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    confirmInfo() {
      this.$router.push({
        path: "/confirmProfile",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        this.tokenBean.token = this.token;
        logout(this.tokenBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
          }
        });
        this.$router.push("/login");
      }
    },
    exit() {
      this.$router.push("/curExam");
    }
  }
};
</script>